/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Place_Home1Inputs */

const vi_cmspost_place_home1 = /** @type {(inputs: Cmspost_Place_Home1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ`)
};

/**

* @param {Cmspost_Place_Home1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_place_home1 = /** @type {((inputs?: Cmspost_Place_Home1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Place_Home1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_place_home1(inputs)
});
export { cmspost_place_home1 as "cmsPost_place_home" }